import {
  ONBOARDING_DOCUMENT_TYPE,
  type DocumentCategory,
  type OnboardingDocumentType,
} from "./types";

// Two kinds of document, and they are not interchangeable. The pay plan is the rules
// written down; reference data is the numbers those rules produced. With only the numbers
// we are reverse-engineering pay, which is slower and a guess.
const DOCUMENT_CATEGORIES: Record<OnboardingDocumentType, DocumentCategory> = {
  [ONBOARDING_DOCUMENT_TYPE.payPlan]: {
    title: "Your pay plan",
    stepTitle: "Send us your pay plan",
    stepSubtitle:
      "How pay is structured for each team, and every rule and bonus that goes with it.",
    asks: [
      "Each team, and how their pay is built",
      "Every bonus and spiff, and who earns it",
      "The edge cases: callbacks, overtime, PTO, anyone on their own deal",
    ],
    // One example, and a thorough one: the point is to show what "specific enough to
    // build from" looks like, including the open questions a real plan still carries.
    // Previewed as a PDF, because a pay plan is a document, and handed over as the Word
    // file they can edit.
    examples: [
      {
        label: "Example Payroll Co pay plan",
        href: "/templates/example_payroll_co_pay_plan.pdf",
        downloadHref: "/templates/example_payroll_co_pay_plan.docx",
      },
    ],
  },
  [ONBOARDING_DOCUMENT_TYPE.referenceData]: {
    title: "Reference data",
    stepTitle: "Send us your recent pay data",
    stepSubtitle:
      "What you actually paid everyone last period, and the reports behind it.",
    asks: [
      "Your most recent pay run, with the total for every person",
      "The reports you pulled to get those totals, exactly as you pulled them",
    ],
    // No examples: an owner does not need showing what their own payroll register looks
    // like, and a fabricated one is a worse guide than the two lines above.
    examples: [],
  },
};

export const documentCategory = (type: OnboardingDocumentType) =>
  DOCUMENT_CATEGORIES[type];
